<template>
  <div v-if="isVisible" class="fixed inset-0 bg-gray-600 bg-opacity-70 z-50 flex justify-center items-center p-4">
    <div class="bg-white dark:bg-gray-800 p-8 rounded-lg w-full max-w-3xl">
      <h2 class="text-xl font-bold dark:text-gray-100 mb-6" v-if="jobId">Send Email for Job #{{ jobId }}</h2>
      <h2 class="text-xl font-bold dark:text-gray-100 mb-6" v-if="ticketId">Send Email for Ticket #{{ ticketId }}</h2>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2">Subject</label>
      <input
        v-model="subject"
        type="text"
        class="w-full p-3 rounded-md border-gray-300 shadow-sm dark:bg-gray-500 dark:border-gray-600 dark:text-gray-100 mb-6"
      />

      <label class="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2">To</label>
      <EmailTypeahead
        v-model="toEmails"
        :addressBook="addressBook"
        placeholder="Type a name or email, press Enter/comma to add"
      />

      <label class="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2 mt-4">CC</label>
      <EmailTypeahead
        v-model="ccEmailsLocal"
        :addressBook="addressBook"
        placeholder="Type a name or email, press Enter/comma to add"
      />

      <label class="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2 mt-4">Body</label>
      <textarea
        v-model="body"
        rows="10"
        class="w-full p-3 rounded-md border-gray-300 shadow-sm dark:bg-gray-500 dark:border-gray-600 dark:text-gray-100 mb-6"
      ></textarea>

      <div class="flex justify-end space-x-3 mt-6">
        <button
          @click="closeModal"
          class="bg-gray-400 hover:bg-gray-600 text-white font-bold py-2 px-5 rounded dark:bg-red-500 dark:hover:bg-red-700"
        >
          Cancel
        </button>
        <button
          @click="sendEmail"
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-5 rounded"
        >
          Send
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EmailTypeahead from "@/views/components/EmailTypeahead.vue";
export default {
  components: { EmailTypeahead },
  props: {
    isVisible: { type: Boolean, required: true },
    jobId: { type: Number, required: false, default: 0 },
    ticketId: { type: Number, required: false, default: 0 },
    requesterName: { type: String, default: "" },
    requesterEmail: { type: String, required: true, default: "" },
    ccEmails: { type: Array, default: () => [] },
    ticketShortDescription: { type: String, default: "" }
  },
  data() {
    return {
      subject: "",
      body: "",
      addressBook: [],
      toEmails: [],
      ccEmailsLocal: []
    };
  },
  watch: {
    async isVisible(newVal) {
      if (!newVal) return;
      this.body = this.buildDefaultBody();
      this.subject = this.ticketId ? `Ticket #${this.ticketId} - ` : '';
      this.toEmails = this.requesterEmail ? [this.requesterEmail] : [];
      this.ccEmailsLocal = Array.isArray(this.ccEmails) ? [...this.ccEmails] : [];
      await this.loadAddressBook();
    }
  },
  methods: {
    buildDefaultBody() {
      const hi = `Hi ${this.requesterName || "there"},\n\n`;

      const desc = this.ticketShortDescription
        ? `Ticket Description: "${this.ticketShortDescription}"\n\n`
        : "";

      return `${desc}${hi}`;
    },
    async loadAddressBook() {
      try {
        this.$updateLoading(1);
        const res = await axios.get("requesters");
        this.$updateLoading(-1);
        this.addressBook = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        console.warn("Failed to load address book, typeahead will be limited.", e);
        this.addressBook = [];
      }
    },
    closeModal() {
      this.$emit("close");
    },
    sendEmail() {
      const to = (this.toEmails || []).map(e => String(e).trim()).filter(Boolean);
      const cc = (this.ccEmailsLocal || []).map(e => String(e).trim()).filter(Boolean);

      if (!to.length) {
        alert("Please add at least one To email.");
        return;
      }
      if (!this.subject || !this.body) {
        alert("Please fill in subject and body.");
        return;
      }

      this.$emit("send", {
        jobId: this.jobId,
        ticketId: this.ticketId,
        subject: this.subject,
        to,
        cc,
        body: this.body
      });

      this.closeModal();
    }
  }
};
</script>